<template>
  <div class="space-y-5">
    <div
      v-if="labels.length > 1"
      class="space-y-2"
    >
      <div class="flex gap-1">
        <span
          v-for="(label, index) in labels"
          :key="label"
          class="h-1.5 flex-1 rounded-full"
          :class="index < step ? 'bg-primary' : 'bg-[var(--ui-border)]'"
        />
      </div>
      <p class="text-xs text-muted">
        مرحلهٔ {{ toFaDigits(step + 1) }} از {{ toFaDigits(labels.length) }}
        <span class="hidden sm:inline"> — {{ labels[step] }}</span>
      </p>
    </div>
    <slot />
    <div class="flex items-center gap-2">
      <UButton
        v-if="showNext"
        class="min-h-11 flex-1 justify-center"
        :loading="loading"
        :disabled="nextDisabled"
        @click="$emit('next')"
      >
        {{ nextLabel }}
      </UButton>
      <UButton
        v-if="step > 0"
        color="neutral"
        variant="soft"
        class="min-h-11 shrink-0"
        trailing-icon="i-lucide-chevron-left"
        @click="$emit('back')"
      >
        مرحلهٔ قبل
      </UButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { toFaDigits } from '~/utils/faDigits'

withDefaults(defineProps<{
  labels: string[]
  step: number
  nextLabel?: string
  nextDisabled?: boolean
  showNext?: boolean
  loading?: boolean
}>(), {
  nextLabel: 'ادامه',
  nextDisabled: false,
  showNext: true,
  loading: false,
})

defineEmits<{ next: []; back: [] }>()
</script>
